import { useQuasar } from "quasar";
import PConfirmDialog from "src/components/PConfirmDialog.vue";
import { unref } from "vue";

export function useCancelProcessing({ closeForm, formData }) {
  const $q = useQuasar();

  const { cancelPaymentRequestProcessing } = usePaymentRequestStore();

  const loading = ref(false);

  const onConfirm = async (dialog) => {
    try {
      loading.value = true;

      dialog?.hide();

      const payload = {
        internal_number: unref(formData).internal_number,
      };

      await cancelPaymentRequestProcessing(payload);

      closeForm();
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
    }
  };

  const confirmCancelProcessing = () => {
    const cancelDialog = $q.dialog({
      component: PConfirmDialog,
      componentProps: {
        text: "Are you sure you want to cancel this processing?",
        isFooterVisible: true,
        submitLabel: "Yes",
        submittable: true,
        cancelLabel: "No",
        cancellable: true,
        closable: true,
        labelClass: "text-center q-ma-xl rounded-borders",
        onConfirm: () => onConfirm(cancelDialog),
      },
    });
  };

  const cancelProcessingButton = computed(() => {
    return {
      loading: unref(loading),
      label: "Cancel Processing",
      type: "button",
      color: "error-70",
      outline: true,
      onClick: confirmCancelProcessing,
    };
  });

  return {
    cancelProcessingButton,
  };
}
